import React, { PureComponent } from 'react'
import cx from 'classnames'
import { compose } from 'helpers'
import toggleOpen from 'local_modules/toggleOpen'
import injectGlobals from 'local_modules/injectGlobals'

import MarketplaceList from '../MarketplaceList/MarketplaceList'
import LayersHeading from '../LayersHeading/LayersHeading'

import s from './WebViewLayers.scss'


class WebViewLayers extends PureComponent {

  UNSAFE_componentWillMount() {
    const { isMobile, projectName, toggleClose } = this.props

    if (isMobile && projectName === 'marketplace') {
      toggleClose()
    }
  }

  render() {
    const {
      isToggleActive, toggleOpen, toggleClose,
    } = this.props

    return (
      <div className={s.container}>
        <LayersHeading
          isToggleActive={isToggleActive}
          toggleOpen={toggleOpen}
          toggleClose={toggleClose}
        />
        <div
          className={cx(s.layersList, {
            [s.active]: isToggleActive,
          })}
        >
          <div
            className={s.layersContainer}
          >
            <MarketplaceList
              className={s.layersContent}
              toggleClose={toggleClose}
            />
          </div>
        </div>
      </div>
    )
  }
}


export default compose(
  injectGlobals(({ globals }) => ({
    isMobile: globals.isMobile,
  })),
  toggleOpen({ isToggleActive: true }),
)(WebViewLayers)
